<footer class="d-flex flex-column align-self-end">
    <div class="container-fluid mt-5 d-none d-md-block">
        <div class="row mb-3 desktop-footer" >
            <div class="col-12 col-md-4 align-self-center">
                <div class="row d-none d-md-flex flex-column">
                    <div class="col text-center d-flex align-items-center justify-content-end">
                        <!-- <div class="col-4 col-xl-5 text-center d-flex align-items-end justify-content-end"> -->
                        <!-- <img style="max-height: 300px" class="img-fluid mb-n3" src="assets/img/mobile-half.png"> -->
                        <!-- </div> -->
                        <!-- <div class="col-8 col-xl-7 d-flex flex-column align-items-center justify-content-around mb-3"> -->
                        <div class="mr-4">
                            <!-- <p class="h2 lemon-milk-regular text-accent">GET A LINK TO THE APP</p> -->
                            <p class="h2 lemon-milk-regular text-accent">Download the app</p>
                            <p class="h3 montserrat-regular">Book your appointments</p>
                        </div>
                        <!-- <form class="form-inline" style="width: 90%">
                            <div class="input-group mb-3 w-100">
                                <input type="text" class="form-control" placeholder="Enter your number">
                                <div class="input-group-append">
                                    <button class="btn btn-dark lemon-milk-light" type="button">Send</button>
                                </div>
                            </div>
                        </form> -->
                        
                    </div>
                    <div class="text-center d-flex justify-content-center">
                        <app-app-store-logos [classes]="['d-flex', 'flex-column']"></app-app-store-logos>
                    </div>
                </div>
            </div>
            <div class="col-md-1 border-right" style="border-right-width: 5px !important;"></div>
            <div class="col-md-1 "></div>
            <div class="col-12 col-md-6 d-flex flex-column justify-content-between">
                <div class="row">
                    <div class="col-12 col-md-6 text-center text-md-left">
                        <h4>Services</h4>
                        <ul class="list-group footer-list-group">
                            <ng-container *ngFor="let category of categories">
                                <li class="list-group-item border-0 p-0">
                                    <a [routerLink]="'/categories/' + category.slug" routerLinkActive="active" (click)="setActiveCategory(category)">{{ category.name }}</a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                    <div class="col-12 col-md-6 text-center text-md-left mt-3 mt-md-0">
                        <h4>Links</h4>
                        <ul class="list-group footer-list-group">
                            <!-- <li class="d-none list-group-item border-0 p-0">
                                <a routerLink="/contact">Contact</a>
                            </li> -->
                            <li *ngIf="has_about_us_page === true" class="list-group-item border-0 p-0">
                                <a routerLink="/about-us">About Us</a>
                            </li>
                            <li *ngIf="has_gallery_page === true" class="list-group-item border-0 p-0">
                                <a routerLink="/gallery">Gallery</a>
                            </li>
                            <!--<li class="list-group-item border-0 p-0">
                                <a routerLink="/404">Terms of Service</a>
                            </li>--> 
                            <li class="list-group-item border-0 p-0">
                                <a routerLink="/privacy-policy">Privacy Policy</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-5 d-flex justify-content-around">
                        <a *ngIf="facebook_url" [href]="facebook_url" class="btn btn-dark">
                            <i class="fab fa-facebook-square mdi-24px mr-0"></i>
                        </a>
                        <a *ngIf="youtube_url" [href]="youtube_url" class="btn btn-dark">
                            <i class="fab fa-youtube mdi-24px mr-0"></i>
                        </a>
                        <a *ngIf="instagram_url" [href]="instagram_url" class="btn btn-dark">
                            <i class="fab fa-instagram mdi-24px mr-0"></i>
                        </a>
                        <a *ngIf="twitter_url" [href]="twitter_url" class="btn btn-dark">
                            <i class="fab fa-twitter mdi-24px mr-0"></i>
                        </a>
                    </div>
                    <div class="col-12 col-md-7 d-flex">
                        <button class="btn btn-dark mx-auto mt-3 mt-md-0 ml-md-auto mr-md-5 d-none">
                            <i class="fas fa-question-circle mdi-24px mr-0"></i> Help
                        </button>
                    </div>
                </div>
            </div>
        </div>



        <div class="row mb-3 ipad-footer">
            <div class="col-12 col-md-12 align-self-center" *ngIf="currentPlatform == 'web'">
                <div class="row d-none d-md-flex flex-column">
                    <div class="text-center">
                     
                        <div class="mr-4">
                            <p class="h2 lemon-milk-regular text-accent">Download the app</p>
                            <p class="h3 montserrat-regular">Book your appointments</p>
                        </div>
                    
                        
                    </div>
                    <div class="text-center d-flex justify-content-center">
                        <app-app-store-logos [classes]="['d-flex', 'flex-column']"></app-app-store-logos>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 mt-5"></div>
            <div class="col-12 col-md-12 m-5 d-flex flex-column justify-content-between">
                <div class="row">
                    <div class="col-12 col-md-6 text-center text-md-left">
                        <h4>Services</h4>
                        <ul class="list-group footer-list-group">
                            <ng-container *ngFor="let category of categories">
                                <li class="list-group-item border-0 p-0">
                                    <a [routerLink]="'/categories/' + category.slug" routerLinkActive="active" (click)="setActiveCategory(category)">{{ category.name }}</a>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                    <div class="col-12 col-md-6 text-center text-md-left mt-3 mt-md-0">
                        <h4>Links</h4>
                        <ul class="list-group footer-list-group">
                            <li *ngIf="has_about_us_page === true" class="list-group-item border-0 p-0">
                                <a routerLink="/about-us">About Us</a>
                            </li>
                            <li *ngIf="has_gallery_page === true" class="list-group-item border-0 p-0">
                                <a routerLink="/gallery">Gallery</a>
                            </li>
                            <li class="list-group-item border-0 p-0">
                                <a routerLink="/privacy-policy">Privacy Policy</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-5 d-flex justify-content-around">
                        <a *ngIf="facebook_url" [href]="facebook_url" class="btn btn-dark">
                            <i class="fab fa-facebook-square mdi-24px mr-0"></i>
                        </a>
                        <a *ngIf="youtube_url" [href]="youtube_url" class="btn btn-dark">
                            <i class="fab fa-youtube mdi-24px mr-0"></i>
                        </a>
                        <a *ngIf="instagram_url" [href]="instagram_url" class="btn btn-dark">
                            <i class="fab fa-instagram mdi-24px mr-0"></i>
                        </a>
                        <a *ngIf="twitter_url" [href]="twitter_url" class="btn btn-dark">
                            <i class="fab fa-twitter mdi-24px mr-0"></i>
                        </a>
                    </div>
                    <div class="col-12 col-md-7 d-flex">
                        <button class="btn btn-dark mx-auto mt-3 mt-md-0 ml-md-auto mr-md-5 d-none">
                            <i class="fas fa-question-circle mdi-24px mr-0"></i> Help
                        </button>
                    </div>
                </div>
            </div>
        </div>










        <div id="copyright-footer" class="row mt-3 bg-dark">
            <div class="col text-center text-light py-3">
                &copy; Bonnie 2021
            </div>
        </div>
    </div>
</footer>